<template>
    <div>
        <DCard
            padding
        >
            <DForm @submit.prevent>
                <div class="code-textarea-container">
                    <DRow>
                        <DCol col="7">
                            <DFormRow
                                class="mb-4"
                                is-vertical
                                :label="__('tools.emails.footer_links.language')"
                                is-required
                                :error="validationErrors['language_code']"
                            >
                                <DSelect
                                    :options="availableLanguages"
                                    :model-value="availableLanguages[0]?.value ?? null"
                                    @update:value="handleLanguageChange"
                                />
                            </DFormRow>
                            <DFormRow
                                :label="__('tools.emails.footer_links.informal_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.informal_content']"
                            >
                                <DFormTextarea
                                    id="informal_content"
                                    v-model="form.informal_content"
                                    rows="15"
                                />
                            </DFormRow>
                            <PreviewText
                                is-html
                                :email-type="emailType"
                                :content="form.informal_content"
                            />
                            <DFormRow
                                :label="__('tools.emails.footer_links.informal_plain_text_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.informal_plain_text_content']"
                            >
                                <DFormTextarea
                                    id="informal_plain_text_content"
                                    v-model="form.informal_plain_text_content"
                                    rows="10"
                                />
                            </DFormRow>
                            <PreviewText
                                :content="form.informal_plain_text_content"
                                :email-type="emailType"
                            />
                            <DFormRow
                                :label="__('tools.emails.footer_links.formal_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.formal_content']"
                            >
                                <DFormTextarea
                                    id="formal_content"
                                    v-model="form.formal_content"
                                    rows="15"
                                />
                            </DFormRow>
                            <PreviewText
                                is-html
                                :content="form.formal_content"
                                :email-type="emailType"
                            />
                            <DFormRow
                                :label="__('tools.emails.footer_links.formal_plain_text_editor')"
                                is-vertical
                                is-required
                                :error="validationErrors['template.formal_plain_text_editor']"
                            >
                                <DFormTextarea
                                    id="formal_plain_text_content"
                                    v-model="form.formal_plain_text_content"
                                    rows="10"
                                />
                            </DFormRow>
                            <PreviewText
                                :content="form.formal_plain_text_content"
                                :email-type="emailType"
                            />
                        </DCol>
                        <DCol col="5">
                            <h2 class="h5">
                                {{ __('tools.emails.footer_legal_info.legend') }}
                            </h2>
                            <EmailPlaceholders :placeholders="placeholders" />
                        </DCol>
                    </DRow>
                </div>
            </DForm>
            <DFabs>
                <DFab
                    id="btn-save"
                    icon="eye"
                    :label="__('messages.preview')"
                    @click="handlePreview"
                />
            </DFabs>
            <EmailEditPreviewModal
                :id="mailModalId"
                :show-modal="showPreviewModal"
                :brands="brands"
                :mailables="mailables"
                :preview-route="previewRoute"
                :content-update-route="contentUpdateRoute"
                :form="form"
                :language="selectedLanguage"
                @closeModal="showPreviewModal=false"
                @modalError="handleModalError"
            />
        </DCard>
    </div>
</template>

<script>
import PreviewText from '~@/Components/Tools/Emails/PreviewText'
import EmailPlaceholders from '~@/Components/Tools/Emails/Placeholders'
import EmailEditPreviewModal from '~@/Components/Tools/Emails/EmailEditPreviewModal'
import preventEmailUrl from '~@/Mixins/preventEmailUrl'

export default {
    name: 'LinkCreate',
    components: { EmailPlaceholders, PreviewText, EmailEditPreviewModal },
    mixins: [
        preventEmailUrl
    ],
    props: {
        placeholders: {
            type: Object,
            default: () => { return {} }
        },
        link: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        mailables: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        availableLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                informal_content: this.link.informal_content,
                formal_content: this.link.formal_content,
                informal_plain_text_content: this.link.informal_plain_text_content,
                formal_plain_text_content: this.link.formal_plain_text_content,
                language_code: this.availableLanguages[0]?.value
            }),
            showPreviewModal: false,
            previewRoute: this.$route('tools.emails.footer-links-preview'),
            contentUpdateRoute: this.$route('tools.emails.footer-links-store'),
            emailType: 'links',
            validationErrors: this.errors,
            mailModalId: 'mailModal',
            selectedLanguage: this.availableLanguages[0]?.value ?? null
        }
    },
    updated () {
        this.preventEmailUrl(this.mailModalId)
    },
    methods: {
        handlePreview () {
            this.showPreviewModal = true
        },
        handleModalError (errorObject) {
            Object.keys(errorObject).forEach((field) => {
                errorObject[field].forEach((message) => {
                    this.validationErrors[field] = message
                })
            })
        },
        getContentForSelectedLanguage () {
            return this.links.filter(item => item.language_code === this.selectedLanguage)[0]
        },
        handleLanguageChange (value) {
            this.form.language_code = value
        }
    }
}
</script>

<style lang="scss">

</style>
